import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import { useLoading } from '../../../context/LoadingContext';
import { toWords } from "number-to-words";

function InventoryDocument({adminData,companyID,branchID}) {

  
  const { setLoading } = useLoading();
     const [noteType, setNoteType] = useState(null);
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [branchDetail, setBranchDetail] = useState([])
   const [showDownloadModal, setShowDownloadModal] = useState(false);
     const [selectedQuotation, setSelectedQuotation] = useState(null);
  const[company,setCompany] = useState([]);
const [showPDFModal, setShowPDFModal] = useState(false);


  
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const reportOptions = [
      { value: 'material_request', label: 'Material Requisition' },
    { value: 'material_issue', label: 'Material Issue' },
  { value: 'material_return', label: 'Material Return' },
   { value: 'stock_transfer', label: 'Stock Transfer' },
  

  ]


  const documentConfig = {
  material_request: {
    title: "Material Requisition",
    prefix: "MR",
  },

  material_issue: {
    title: "Material Issue Note",
    prefix: "MIN",
  },

  material_return: {
    title: "Material Return Note",
    prefix: "MRN",
  },

  stock_transfer: {
    title: "Stock Transfer Note",
    prefix: "ST",
  },
};


const isMaterial = (type) =>
  ["material_request", "material_issue", "material_return", "stock_transfer"].includes(type);


const numberToWords = (amount) => {
  if (!amount) return "";

  const num = Number(amount);
  if (isNaN(num)) return "";

  const words = toWords(num);

  return words
    .replace(/-/g, " ") 
    .split(" ")
    .filter(Boolean)
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
};

    const fetchBranchDetail = async () => {
      setLoading(true)
    try {
      const resInventory = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
       setBranchDetail(resInventory.data)

    } catch (error) {
      console.log(error)
    } finally {
     setLoading(false);
        }
  };




    const fetchCompany = async () => {
      setLoading(true)
    try {
      const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
      setCompany(res.data);

    } catch (error) {
      console.log(error)
    } finally {
     setLoading(false);
        }
  };


   useEffect(() => {
  
      fetchBranchDetail();
      fetchCompany();
    }, []);



const handleSearch = async (e) => {
  e.preventDefault();

  const isPriceList = noteType?.value === 'price_list';

 
  if (!isPriceList && (!fromDate || !toDate)) {
    setToast('Please select both From Date and To Date', 'warning');
    return;
  }

  try {
    const params = {
      note_type: noteType?.value,
      from_date:fromDate,
      to_date:toDate
    };

    if (!isPriceList) {
      params.from_date = fromDate;
      params.to_date = toDate;
    }

    const result = await axios.get(
      'https://api.skyguard.group/api/get-inventory-document',
      { params }
    );

    const resultData = result?.data?.result || [];
     console.log('list',resultData);


    setfetchData(resultData);

 

    if (resultData.length > 0) {
      setToast('Report fetched successfully', 'success');
    } else {
      setToast('No data found in selected date range', 'warning');
    }

  } catch (error) {
    console.error('❌ Error fetching report:', error);
    setToast('Error fetching report. Please try again.', 'danger');
  }
};


  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };

    const handleExportExcel = () => {
      const table = document.getElementById("exportTable");
    
      if (!table) return;
    
      const worksheet = XLSX.utils.table_to_sheet(table);
      const workbook = XLSX.utils.book_new();
    
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
    
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
    
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
    
      saveAs(data, "Sale_Report.xlsx");
    };


    
const handlePrint = () => {
  const printContents = document.getElementById("invoice-print-area").innerHTML;
  const originalContents = document.body.innerHTML;

  // Open a new window for printing
  const printWindow = window.open("", "_blank", "width=900,height=600");
  printWindow.document.write(`
    <html>
      <head>
     
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          table, th, td { border: 1px solid #000; }
          th, td { padding: 5px; text-align: center; }
          .text-start { text-align: left; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

const handleDownloadPDF = () => {
  const doc = new jsPDF("p", "mm", "a4");

  doc.setFontSize(16);
  doc.text("Sale Documents Report", 14, 15);

  let tableColumn = [];
  let tableRows = [];

  // Different table structure based on selected type
  if (noteType?.value === "sale_quotation") {
    tableColumn = [
      "Doc No",
      "Date",
      "Party",
      "Address",
      "Item",
      "Rate",
      "Description",
      "Added By",
      "Created At",
    ];

    fetchData.forEach((item) => {
      let items = [];

      try {
        items = JSON.parse(item.items || "[]");
      } catch {
        items = [];
      }

      const itemNames = items
        .map((it) => `${it.name} (Qty:${it.qty})`)
        .join(", ");

      const rates = items.map((it) => it.rate).join(", ");

      const rowData = [
        `SQ/${item.inv_no}/${item.branchId}`,
        item.payment_date,
        item.party_name,
        item.party_address,
        itemNames,
        rates,
        item.remark,
        `${item.emp_first || ""} ${item.emp_middle || ""} ${item.emp_last || ""}`,
        item.created_at,
      ];

      tableRows.push(rowData);
    });
  }

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 25,
    styles: {
      fontSize: 8,
      cellPadding: 2,
    },
    headStyles: {
      fillColor: [41, 128, 185],
    },
  });

  doc.save("Sale_Report.pdf");
};


const handleSaveMergedPDF = async () => {

  const pdf = new jsPDF("p", "mm", "a4");

  const pages = document.querySelectorAll(".pdf-page");

  for (let i = 0; i < pages.length; i++) {

    const canvas = await html2canvas(pages[i], {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");

    const imgWidth = 210;

    const imgHeight =
      (canvas.height * imgWidth) / canvas.width;

    if (i > 0) {
      pdf.addPage();
    }

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      imgWidth,
      imgHeight
    );
  }

  pdf.save("All_Inventory_Bills.pdf");
};



  return (
    <div className='main-section'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
  
            <h3 className='my-3 fw-bold fs-5 golos'>Inventory Documents</h3>
  
  
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className='fw-bold'>Select Document</label>
                <Select
                  options={reportOptions}
                  placeholder="Choose Type ..."
                  id="source"
                  value={noteType}
  
                  onChange={(selected) => {
                    setNoteType(selected);
                    setfetchData([]);
                  }}
                />
              </div>
  
              <div className="col-md-4">
                <label className='fw-bold'>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="from_date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
  
              <div className="col-md-4">
                <label className='fw-bold'>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="to_date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
  
  
              <div className="col-md-12 d-flex justify-content-end align-items-end">
                {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
                 <FaSearch size={26} className="ms-1 text-primary"
                                style={{ cursor: "pointer" }}
                                title="Search"
                                onClick={handleSearch}
                              />
                
                              <MdLocalPrintshop
                                size={26}
                                className="ms-1 text-success me-1"
                                   onClick={handleExportExcel}
                                style={{ cursor: "pointer" }}
                                title="Print "
                              />
  
                            <button
    className='btn btn-warning'
    onClick={() => setShowPDFModal(true)}
  >
    Download PDF
  </button>
              </div>
            </div>
  
            <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
              {isMaterial(noteType?.value) && (
                <table  className='table table-bordered table-striped table-hover text-center align-middle'>
                  <thead className='table-info'>
                    <tr>
                      <th>Doc No</th>
                      <th>Date</th>
                        <th>Emp Name</th>
                        <th>Item</th>
                        <th>Rate</th>
                        <th>Description</th>
                        
                    
                    </tr>
                  </thead>
                  <tbody>
               {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
  
      let items = [];
      try {
        items = JSON.parse(item.items || "[]");
      } catch (e) {
        items = [];
      }


         const totalAmount = items.reduce(
        (sum, it) => sum + Number(it.amount || 0),
        0
      );
  
      return (
        <tr key={idx}>
  
        

   <td>{`${documentConfig?.[noteType?.value]?.prefix}/${item.id}/${item.branchId || item.from_branch_code}`}</td>
  
          <td>{item.quotation_date}</td>
  
          
          <td>{item.emp_first || ""} {item.emp_middle || ""} {item.emp_last || ""}  </td>
  
      
          <td style={{ whiteSpace: "nowrap" }}>
            {items.map((it, i) => (
              <div key={i}>
                {it.name} (Qty: {it.qty})
              </div>
            ))}
          </td>
  
 
          <td>
            {items.map((it, i) => (
              <div key={i}>
                {it.rate}
              </div>
            ))}
          </td>

          
  
     
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>
            {item.remark}
          </td>
  

  
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No data found</td>
    </tr>
  )}
                  </tbody>
                </table>
              )}
  
            </div>
  
  
  {showPDFModal && (
    <div
      className="position-fixed top-0 start-0 w-100 h-100"
      style={{
        background: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        overflowY: "auto",
        padding: "20px",
      }}
    >
  
   {/* CENTER WRAPPER */}
  <div
    style={{
      width: "210mm",
      margin: "0 auto",
    }}
  >
  
    {/* TOP HEADER */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#fff",
        padding: "12px 20px",
        borderRadius: "8px",
        marginBottom: "10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
  
  
      <h3
        style={{
          margin: 0,
          fontWeight: "700",
          color: "#222",
        }}
      >
      Preview {documentConfig?.[noteType?.value]?.title || "Document"}
      </h3>
  
      <div
        style={{
          display: "flex",
          gap: "10px",
        }}
      >
  
        <button
          className="btn btn-success"
          onClick={handleSaveMergedPDF}
        >
          Save PDF
        </button>
  
        <button
          className="btn btn-danger"
          onClick={() => setShowPDFModal(false)}
        >
          Close
        </button>
  
      </div>
  
    </div>
  
  </div>
  
      <div id="all-bills-pdf">
  
        {fetchData.map((quotation, index) => {
  
          let parsedItems = [];
  
          try {
            parsedItems = JSON.parse(quotation.items || "[]");
          } catch {
            parsedItems = [];
          }
  
          let parsedAdditionalDetails = [];
  
          try {
            parsedAdditionalDetails = JSON.parse(
              quotation.additional_charges || "[]"
            );
          } catch {
            parsedAdditionalDetails = [];
          }
  
       
  
          const headerImageUrl =
            `https://api.skyguard.group/uploads/${branchDetail.header_img}`;
  


            const tableHeader = {
  padding: "8px",
  fontSize: "13px",
  fontWeight: "bold",
};

const tableCell = {
  padding: "8px",
  fontSize: "13px",
  textAlign: "center",
};


const totalAmount = parsedItems.reduce(
  (sum, item) => sum + Number(item.amount || 0),
  0
);

          return (
  
          <div
  key={index}
  className="pdf-page"
  style={{
    width: "210mm",
    minHeight: "297mm",
  margin: "5px auto",
    background: "#fff",
   padding: "10mm 12mm",
    boxSizing: "border-box",
    pageBreakAfter: "always",
    position: "relative",
    fontFamily: "Arial",
  }}
>

 

  <div style={{ position: "relative", zIndex: 1 }}>


<div
  style={{
   textAlign: "center",
    borderBottom: "1px solid #000",
    paddingBottom: "8px",
    marginBottom: "10px",
  }}
>
  
   <div
    style={{
      fontSize: "24px",
      fontWeight: "700",
      lineHeight: "28px",
      margin: 0,
      padding: 0,
    }}
  >
    {company.name}
  </div>

  {/* ADDRESS */}
  <div
    style={{
      fontSize: "13px",
      marginTop: "3px",
      lineHeight: "18px",
      whiteSpace: "pre-line",
    }}
  >
    {company.address}
  </div>

  {/* GST */}
  <div
    style={{
      fontSize: "13px",
      marginTop: "2px",
   
    }}
  >
    GSTIN NO : {company.gst}
  </div>

  {/* DOCUMENT TITLE */}
  <div
    style={{
      marginTop: "10px",
      fontSize: "20px",
      fontWeight: "700",
      letterSpacing: "0.5px",
    }}
  >
    {documentConfig?.[noteType?.value]?.title}
  </div>

</div>

{/* ===== DOCUMENT INFO ===== */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "12px",
    fontSize: "13px",
  }}
>

  {/* LEFT SECTION */}
  <div
    style={{
      lineHeight: "22px",
    }}
  >
    <div>
         Ref Doc :
      <strong>
        {documentConfig?.[noteType?.value]?.prefix}/
        {quotation.id}/
        {quotation.branchId || quotation.from_branch_code}
      </strong>
    </div>

    <div>
      Employee :
      {" "}
      {quotation.emp_first}
      {" "}
      {quotation.emp_middle}
      {" "}
      {quotation.emp_last}
    </div>
  </div>

  {/* RIGHT SECTION */}
  <div
    style={{
      textAlign: "right",
      lineHeight: "22px",
    }}
  >
    <div>
      Date :
      {" "}
      {quotation.quotation_date}
    </div>

    <div>
      Branch :
      {" "}
      {branchDetail.name}
    </div>

       <div>
     To  Branch :
      {" "}
      {quotation.to_branch_name || ""}
    </div>
  </div>

</div>
{/* LINE */}
<div
  style={{
    borderBottom: "1px solid #000",
    marginBottom: "10px",
  }}
/>

    {/* TABLE */}
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px",
      }}
    >
      <thead>
        <tr
          style={{
            borderTop: "1px solid #000",
            borderBottom: "1px solid #000",
          }}
        >
          <th style={tableHeader}>SrNo</th>
          <th style={{ ...tableHeader, textAlign: "left" }}>
            Description
          </th>
          <th style={tableHeader}>Qty</th>
          <th style={tableHeader}>Rate</th>
          <th style={tableHeader}>Amount</th>
        </tr>
      </thead>

      <tbody>
        {parsedItems.map((item, i) => (
          <tr key={i}>
            <td style={{
                ...tableCell,
                textAlign: "left",
              }}>{i + 1}</td>

            <td
              style={{
                ...tableCell,
                textAlign: "left",
              }}
            >
              {item.name}
            </td>

            <td style={{
                ...tableCell,
                textAlign: "left",
              }}>
              {item.qty}
            </td>

            <td style={{
                ...tableCell,
                textAlign: "left",
              }}>
              {item.rate}
            </td>

            <td style={{
                ...tableCell,
                textAlign: "left",
              }}>
              {item.amount || 0}
            </td>
          </tr>
        ))}

         {noteType?.value === "stock_transfer" && (
    <tr
      style={{
        borderTop: "1px solid #000",
        fontWeight: "bold",
      }}
    >
      <td colSpan={4}
        style={{
          ...tableCell,
          textAlign: "right",
          paddingRight: "10px",
        }}
      >
        Total
      </td>

      <td
        style={{
          ...tableCell,
          textAlign: "left",
        }}
      >
        {totalAmount.toFixed(2)}
      </td>
    </tr>
  )}
      </tbody>
    </table>

  

    {/* REMARK */}
    <div
      style={{
        marginTop: "20px",
        fontSize: "13px",
      }}
    >
      <strong>Remark :</strong>
      {" "}
      {quotation.remark}
    </div>


    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "80px",
        fontSize: "14px",
      }}
    >
      <div>
        Checked By
        <div
          style={{
            borderTop: "1px solid #000",
            width: "150px",
            marginTop: "30px",
          }}
        />
      </div>

      <div>
        Issued By
        <div
          style={{
            borderTop: "1px solid #000",
            width: "150px",
            marginTop: "30px",
          }}
        />
      </div>

      <div>
        Received By
        <div
          style={{
            borderTop: "1px solid #000",
            width: "150px",
            marginTop: "30px",
          }}
        />
      </div>
    </div>

  </div>
</div>
          );
        })}
      </div>
  
  
  
      {/* CSS */}
      <style>
        {`
        .invoice-table {
          width: 100%;
          border-collapse: collapse;
        }
  
        .invoice-table td,
        .invoice-table th {
          border: 1px solid #000;
          padding: 5px;
          font-size: 12px;
        }
  
        @media print {
          .pdf-page {
            margin: 0;
            box-shadow: none;
          }
        }
        `}
      </style>
  
    </div>
  )}
  

          </div>
        </div>
  )
}

export default InventoryDocument